module.exports = __webpack_public_path__ + "static/media/calculator-result-all-pass.fb45fee3.png";